import { Space, Button as AntButton, Tooltip, Modal, message } from 'antd';
import React, { useState, useEffect } from 'react';
import { Card, Row, CardBody, Container, Button } from "reactstrap";
import Iconify from "../../reusable/Iconify";
import { Col, } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomTable from "../../reusable/CustomTable";
import Palette from "../../../utils/Palette";
import SubCategoryFormModal from './SubCategoryFormModal';
import SubCategory from 'models/SubCategoryModel';

const SubCategoryList = () => {

  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null)
  const [openSubCategoryModal, setOpenSubCategoryModal] = useState(false)
  const [isNewRecord, setIsNewRecord] = useState(false)

  const columns = [
    {
      id: 'id', label: 'ID', filter: false, allowSort: false,
    },
    {
      id: 'name', label: 'Name', filter: true,
      render: ((row) => row.name || row.name_tl || '-'),
    },
    {
      id: 'description', label: 'Description', filter: false, allowSort: false,
    },
    {
      id: '', label: '', filter: false,
      render: ((row) => {
        return (
          <>
            <Space size="small">
              <Tooltip title="Edit">
                <AntButton
                  type={'link'}
                  style={{ color: Palette.MAIN_THEME }}
                  onClick={() => {
                    setOpenSubCategoryModal(true)
                    setSelectedSubCategory(row)
                    setIsNewRecord(false)
                  }}
                  className={"d-flex align-items-center justify-content-center"}
                  shape="circle"
                  icon={<Iconify icon={"material-symbols:edit"} />} />
              </Tooltip>
              <Tooltip title="Delete">
                <AntButton
                  type={'link'}
                  style={{ color: Palette.MAIN_THEME }}
                  onClick={() => {
                    onDelete(row.id)
                  }}
                  className={"d-flex align-items-center justify-content-center"}
                  shape="circle"
                  icon={<Iconify icon={"material-symbols:delete-outline"} />} />
              </Tooltip>
            </Space>
          </>
        )

      })
    },
  ]

  const deleteItem = async (id) => {
    try {
      await SubCategory.delete(id)
      message.success('Sub category deleted')
      initializeData();
    } catch (e) {
      message.error('There was error from server')
      setLoading(true)
    }
  }

  const onDelete = (record) => {
    Modal.confirm({
      title: "Are you sure you want to delete this sub category data?",
      okText: "Yes",
      okType: "danger",
      onOk: () => {
        deleteItem(record)
      }
    });
  };

  const initializeData = async () => {
    setLoading(true)
    try {
      let result = await SubCategory.getAll();
      console.log(result)
      setDataSource(result)
      setLoading(false)
    } catch (e) {
      setLoading(false)
    }
  }

  useEffect(() => {
    initializeData()
  }, [])

  return (
    <>
      <Container fluid>
        <Card style={{ background: Palette.BACKGROUND_DARK_GRAY, color: "white" }}
          className="card-stats mb-4 mb-xl-0">
          <CardBody>

            <Row>
              <Col className='mb-3' md={6}>
                <div style={{ fontWeight: "bold", fontSize: "1.1em" }}>Sub Categories</div>
              </Col>
              <Col className='mb-3 text-right' md={6}>
                <Space size="middle">
                  <Link to="/sub-categories/bulk-upload">
                  </Link>
                  <AntButton onClick={() => {
                    setIsNewRecord(true)
                    setOpenSubCategoryModal(true)
                  }} size={'middle'} type={'primary'}>Add Sub Category</AntButton>
                </Space>
              </Col>
            </Row>
            <Row>

            </Row>
            <CustomTable
              showFilter={true}
              pagination={true}
              searchText={''}
              data={dataSource}
              columns={columns}
            />
          </CardBody>
        </Card>

      </Container>

      <SubCategoryFormModal
        isOpen={openSubCategoryModal}
        isNewRecord={isNewRecord}
        subCategoryData={selectedSubCategory}
        close={async (refresh) => {
          if (refresh) {
            await initializeData()
          }
          setOpenSubCategoryModal(false)
        }}
      />

    </>
  )
}

export default SubCategoryList;
